import { render } from "./audioPlayer2.vue?vue&type=template&id=9c3ff99c&scoped=true"
import script from "./audioPlayer2.vue?vue&type=script&lang=js"
export * from "./audioPlayer2.vue?vue&type=script&lang=js"

import "./audioPlayer2.vue?vue&type=style&index=0&id=9c3ff99c&lang=scss&scoped=true"
import "./audioPlayer2.vue?vue&type=style&index=1&id=9c3ff99c&lang=scss"
script.render = render
script.__scopeId = "data-v-9c3ff99c"

export default script